import { Navigate, useSearchParams, useNavigate, createSearchParams } from "react-router-dom";
import { SearchVacancies, VacanciesList } from "../../widget";
import { SearchParamsVacancyEnum } from "../../shared/constants/searchParams";
import { removeNullKeys } from "../../shared/lib/helpers";
import type { FormVacancy } from "../../widget/SearchVacancies";
import { Button } from "../../shared/ui";

import { RoutesEnum, getRouteVacancies } from "../../shared/constants/routes";
import { useGetDirectionVacancyListQuery } from "../../entities/Vacancy/api/vacancyApi";
import { useState } from "react";
import styles from "./DirectionPage.module.scss";

const DEFAULT_VACANCIES_TO_SHOW = 10;

export const DirectionPage = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [visible, setVisible] = useState(DEFAULT_VACANCIES_TO_SHOW);

    const direction = searchParams.get(SearchParamsVacancyEnum.DIRECTION);
    const searchValue = searchParams.get(SearchParamsVacancyEnum.SEARCH) ?? "";
    const cityValue = searchParams.get(SearchParamsVacancyEnum.CITY) ?? "";
    const experienceValue = searchParams.get(SearchParamsVacancyEnum.EXPERIENCE) ?? "";
    const { data: vacancyList, isLoading } = useGetDirectionVacancyListQuery({
        directionId: direction,
        SearchString: searchValue,
        City: cityValue,
        JobExperience: experienceValue,
        [SearchParamsVacancyEnum.TAKE]: visible,
    });

    if (!direction) {
        return <Navigate to={RoutesEnum.NotFound} />;
    }

    const handleUpdateSearchParams = ({ directionId, ...data }: FormVacancy) => {
        if (directionId) {
            setSearchParams(removeNullKeys({ directionId, ...data }), { preventScrollReset: true });
        } else {
            navigate({
                pathname: getRouteVacancies(),
                search: createSearchParams(removeNullKeys(data)).toString(),
            });
        }
    };

    const handleShowMoreCard = () => {
        setVisible((prev) => prev + DEFAULT_VACANCIES_TO_SHOW);
    };

    const hasMoreVacancies = visible <= (vacancyList?.vacancies?.length ?? 0);

    return (
        <>
            <SearchVacancies countVacancies={vacancyList?.count ?? 0} onSetParams={handleUpdateSearchParams} />
            <VacanciesList
                isLoading={isLoading}
                vacancyList={vacancyList ? [vacancyList] : undefined}
                renderButton={() =>
                    hasMoreVacancies ? (
                        <Button as="button" onClick={handleShowMoreCard} className={styles.button}>
                            Больше вакансий
                        </Button>
                    ) : null
                }
            />
        </>
    );
};
